import { withTranslation } from "react-i18next";
import PointSpendLogs from './PointSpendLog';
import connect from "react-redux/es/connect/connect";
import * as orderActions from './../../../../../../actions/orderAction';

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        refundOrderPoint: (id) => dispatch(orderActions.refundOrderPointAction(id)),
        getPointHistories: (id) => dispatch(orderActions.getPointHistoriesAction(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PointSpendLogs));
